import { Box, Collapse, List, ListItem, ListItemButton, Typography, useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import { ExpandLess, ExpandMore, Inbox, QuestionAnswer, Task, Today, MenuBook, Domain } from '@mui/icons-material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import ShareIcon from '@mui/icons-material/Share';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import TodayIcon from '@mui/icons-material/Today';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventNoteIcon from '@mui/icons-material/EventNote';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SchoolIcon from '@mui/icons-material/School';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
// import GroupsIcon from '@mui/icons-material/Groups';
import { darkGrey, headingBlue, maroon, pureWhite } from '../../assets/colors';

const SideDrawer = (props) => {

    console.log("props: ", props)
    const isMobile = useMediaQuery("(max-width:600px)");

    const [smpOpen, setSMPOpen] = useState(props.selectedDashboard === 'Daily Task' ? true : false)
    const [isHovered, setIsHovered] = useState(0)
    const [isClicked, setIsclicked] = useState(props.selectedDashboard === 'Daily Task' ? 3.2 : props.selectedDashboard === 'Chapters' ? 10 : 1)

    var mainContainerStyle= {
        width: isMobile ? '25vw' : '15vw',
        minHeight: '91vh',
    //  border: '1px solid'  
        borderRight: '1px solid #D9D9D9',
        // backgroundColor: pur,
        fontWeight: 600
    }

    var typographyStyle = {
        padding: '0.1rem 0.4rem 0.1rem 0.6rem'
    }

  return (
    <>
        <Box style={mainContainerStyle}>
            <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.75rem 0.5rem 0.75rem 0.5rem', borderBottom: `1px solid #D9D9D9`}}>
                <img src={require('../../assets/images/WORK_logo.png')} style={{ width: '50%'}}></img>
            </Box>
            
            <List style={{padding: '0rem'}}>
                {
                ((localStorage.getItem('designation') === 'admin')  || (localStorage.getItem('isDistrictHead') === 'true' || localStorage.getItem('isStateHead') === 'true')) && 
                    <ListItemButton 
                        onClick={() => {
                        setIsclicked(1)
                        setSMPOpen(false)
                            props.updateSelectedDashboard('WORKers')}}
                        style={{color: isHovered === 1 || isClicked === 1 ? pureWhite :headingBlue, 
                            backgroundColor: isHovered === 1 || isClicked === 1 ? headingBlue : pureWhite
                        }}
                        onMouseEnter={() => setIsHovered(1)}
                        onMouseLeave={() => setIsHovered(0)}
                    >
                        <Diversity3Icon></Diversity3Icon>
                        {!isMobile &&
                        <Typography style={typographyStyle}> WORKers</Typography>}
                    </ListItemButton>
                }
                {(localStorage.getItem('designation') === 'admin') && 
                    <ListItem
                        onClick={() => {
                            setIsclicked(5)
                            setSMPOpen(false)
                            props.updateSelectedDashboard('task')
                        }}
                        style={{color: isHovered === 5 || isClicked === 5 ? pureWhite :headingBlue, 
                            backgroundColor: isHovered === 5 || isClicked === 5 ? headingBlue : pureWhite}}
                            onMouseEnter={() => setIsHovered(5)}
                            onMouseLeave={() => setIsHovered(0)}
                        >
                        <Task></Task>
                        {!isMobile &&
                            <Typography style={typographyStyle}> Tasks</Typography>
                        }

                    </ListItem>
                }
                {(localStorage.getItem('designation') === 'admin'|| (localStorage.getItem('isDistrictHead') === 'true' || localStorage.getItem('isStateHead') === 'true')) && 
                    <ListItem
                        onClick={() => {
                            setIsclicked(7)
                            setSMPOpen(false)
                            props.updateSelectedDashboard('training')
                        }}
                        style={{color: isHovered === 7 || isClicked === 7 ? pureWhite :headingBlue, 
                            backgroundColor: isHovered === 7 || isClicked === 7 ? headingBlue : pureWhite}}
                            onMouseEnter={() => setIsHovered(7)}
                            onMouseLeave={() => setIsHovered(0)}
                        >
                        <SchoolIcon></SchoolIcon>
                        {!isMobile &&
                            <Typography style={typographyStyle}> Training</Typography>
                        }
                    </ListItem>
                }
                {(localStorage.getItem('designation') === 'admin') && 
                    <ListItem
                        onClick={() => {
                            setIsclicked(9)
                            setSMPOpen(false)
                            props.updateSelectedDashboard('courses')
                        }}
                        style={{color: isHovered === 9 || isClicked === 9 ? pureWhite :headingBlue, 
                            backgroundColor: isHovered === 9 || isClicked === 9 ? headingBlue : pureWhite}}
                            onMouseEnter={() => setIsHovered(9)}
                            onMouseLeave={() => setIsHovered(0)}
                        >
                        <MenuBook></MenuBook>
                        {!isMobile &&
                            <Typography style={typographyStyle}> Course & Quiz</Typography>
                        }
                    </ListItem>
                }
                {((localStorage.getItem('designation') === 'admin')  || (localStorage.getItem('isDistrictHead') === 'true' || localStorage.getItem('isStateHead') === 'true')) &&
                <ListItemButton 
                    onClick={() => {
                        setIsclicked(2)
                        setSMPOpen(false)
                        props.updateSelectedDashboard('chapterLeads')
                    }}
                    style={{color: isHovered === 2 || isClicked === 2 ? pureWhite :headingBlue, 
                        backgroundColor: isHovered === 2 || isClicked === 2 ? headingBlue : pureWhite}}
                    onMouseEnter={() => setIsHovered(2)}
                    onMouseLeave={() => setIsHovered(0)}
                >
                    <PersonAddIcon></PersonAddIcon>
                    {!isMobile &&
                    <Typography style={typographyStyle}> Leads</Typography>}
                </ListItemButton>}

                {((localStorage.getItem('designation') === 'admin')  || (localStorage.getItem('isDistrictHead') === 'true' || localStorage.getItem('isStateHead') === 'true')) &&
                <ListItemButton 
                    onClick={() => {
                        setIsclicked(6)
                        setSMPOpen(false)
                        props.updateSelectedDashboard('registrationHub')
                    }}
                    style={{color: isHovered === 6 || isClicked === 6 ? pureWhite :headingBlue, 
                        backgroundColor: isHovered === 6 || isClicked === 6 ? headingBlue : pureWhite}}
                    onMouseEnter={() => setIsHovered(6)}
                    onMouseLeave={() => setIsHovered(0)}
                >
                    <AppRegistrationIcon />
                    {!isMobile &&
                    <Typography style={typographyStyle}> Registration Hub</Typography>}
                </ListItemButton>
                }

                {(localStorage.getItem('designation') === 'admin') &&
                <ListItemButton 
                    onClick={() => {
                        setIsclicked(10)
                        setSMPOpen(false)
                        props.updateSelectedDashboard('Chapters')
                    }}
                    style={{color: isHovered === 10 || isClicked === 10 ? pureWhite : headingBlue, 
                        backgroundColor: isHovered === 10 || isClicked === 10 ? headingBlue : pureWhite}}
                    onMouseEnter={() => setIsHovered(10)}
                    onMouseLeave={() => setIsHovered(0)}
                >
                    <Domain />
                    {!isMobile &&
                    <Typography style={typographyStyle}> Chapters Management</Typography>}
                </ListItemButton>
                }

                {/* {((localStorage.getItem('designation') === 'admin')  || (localStorage.getItem('isDistrictHead') === 'true' || localStorage.getItem('isStateHead') === 'true')) &&
                <ListItemButton 
                    onClick={() => {
                        setIsclicked(8)
                        setSMPOpen(false)
                        props.updateSelectedDashboard('committees')
                    }}
                    style={{color: isHovered === 8 || isClicked === 8 ? pureWhite :headingBlue, 
                        backgroundColor: isHovered === 8 || isClicked === 8 ? headingBlue : pureWhite}}
                    onMouseEnter={() => setIsHovered(8)}
                    onMouseLeave={() => setIsHovered(0)}
                >
                    <GroupsIcon />
                    {!isMobile &&
                    <Typography style={typographyStyle}> Committees</Typography>}
                </ListItemButton>
                } */}

                {(localStorage.getItem('designation') === 'admin'|| (localStorage.getItem('isDistrictHead') === 'true' || localStorage.getItem('isStateHead') === 'true')) && 
                    <ListItem
                        onClick={() => {
                            setIsclicked(4)
                            setSMPOpen(false)
                            props.updateSelectedDashboard('pollTemplates')
                        }}
                        style={{color: isHovered === 4 || isClicked === 4 ? pureWhite :headingBlue, 
                            backgroundColor: isHovered === 4 || isClicked === 4 ? headingBlue : pureWhite}}
                            onMouseEnter={() => setIsHovered(4)}
                            onMouseLeave={() => setIsHovered(0)}
                        >
                        <QuestionAnswer></QuestionAnswer>
                        {!isMobile &&
                            <Typography style={typographyStyle}> Poll</Typography>
                        }

                    </ListItem>
                }
                {localStorage.getItem('designation') && 
                ['admin', 'supervisor', 'incharge'].includes(localStorage.getItem('designation')) &&
                <>
                    <ListItemButton
                        onClick={() => {
                            setSMPOpen(!smpOpen)
                        }}
                        style={{
                            display: 'flex', justifyContent: 'space-between',
                            // color: parseInt(isHovered) === 3 || parseInt(isClicked) === 3 ? pureWhite :headingBlue, 
                            // backgroundColor: parseInt(isHovered) === 3 || parseInt(isClicked) === 3 ? headingBlue : pureWhite
                            color: headingBlue, 
                            backgroundColor: pureWhite
                        }}
                        // onMouseEnter={() => setIsHovered(3)}
                        // onMouseLeave={() => setIsHovered(0)}
                    >
                        <ShareIcon></ShareIcon>
                        {!isMobile &&
                        <Typography style={typographyStyle}> Social Media Project</Typography>}
                        
                        {smpOpen ? <ExpandLess/> : <ExpandMore/>}
                        
                    </ListItemButton>

                    <Collapse in={smpOpen} timeout="auto" unmountOnExit>
                        <List style={{padding: '0rem'}}>
                            <ListItemButton 
                                onClick={() => {
                                    setIsclicked(3.1)
                                    props.updateSelectedDashboard('One Time Task')
                                }}
                                style={{
                                    display: 'flex', 
                                    // justifyContent: 'space-between',
                                    color: isHovered === 3.1 || isClicked === 3.1 ? pureWhite :headingBlue, 
                                    backgroundColor: isHovered === 3.1 || isClicked === 3.1 ? headingBlue : pureWhite
                                }}
                                onMouseEnter={() => setIsHovered(3.1)}
                                onMouseLeave={() => setIsHovered(0)}
                            >
                                <LooksOneIcon></LooksOneIcon>
                                {!isMobile &&
                                <Typography style={{...typographyStyle}}>One Time Tasks</Typography>}
                            </ListItemButton>
                            <ListItemButton 
                                onClick={() => {
                                    setIsclicked(3.2)
                                    props.updateSelectedDashboard('Daily Task')
                                }}
                                style={{
                                    display: 'flex',
                                    //  justifyContent: 'space-between',
                                    color: isHovered === 3.2 || isClicked === 3.2 ? pureWhite :headingBlue, 
                                    backgroundColor: isHovered === 3.2 || isClicked === 3.2 ? headingBlue : pureWhite
                                }}
                                onMouseEnter={() => setIsHovered(3.2)}
                                onMouseLeave={() => setIsHovered(0)}
                            >
                                <TodayIcon></TodayIcon>
                                {!isMobile &&
                                <Typography style={{...typographyStyle}}>Daily Tasks</Typography>}
                            </ListItemButton>
                            <ListItemButton 
                                onClick={() => {
                                    setIsclicked(3.3)
                                    props.updateSelectedDashboard('Weekly Task')
                                }}
                                style={{
                                    display: 'flex',
                                    //  justifyContent: 'space-between',
                                    color: isHovered === 3.3 || isClicked === 3.3 ? pureWhite :headingBlue, 
                                    backgroundColor: isHovered === 3.3 || isClicked === 3.3 ? headingBlue : pureWhite
                                }}
                                onMouseEnter={() => setIsHovered(3.3)}
                                onMouseLeave={() => setIsHovered(0)}
                            >
                                <DateRangeIcon></DateRangeIcon>
                                {!isMobile &&
                                <Typography style={{...typographyStyle}}>Weekly Tasks</Typography>}
                            </ListItemButton>
                            <ListItemButton 
                                onClick={() => {
                                    setIsclicked(3.4)
                                    props.updateSelectedDashboard('Monthly Task')
                                }}
                                style={{
                                    display: 'flex', 
                                    // justifyContent: 'space-between',
                                    color: isHovered === 3.4 || isClicked === 3.4 ? pureWhite :headingBlue, 
                                    backgroundColor: isHovered === 3.4 || isClicked === 3.4 ? headingBlue : pureWhite
                                }}
                                onMouseEnter={() => setIsHovered(3.4)}
                                onMouseLeave={() => setIsHovered(0)}
                            >
                                <EventNoteIcon></EventNoteIcon>
                                {!isMobile &&
                                <Typography style={{...typographyStyle}}>Monthly Tasks</Typography>}
                            </ListItemButton>
                            <ListItemButton 
                                onClick={() => {
                                    setIsclicked(3.5)
                                    props.updateSelectedDashboard('Members')}}
                                style={{
                                    display: 'flex', 
                                    // justifyContent: 'space-between',
                                    color: isHovered === 3.5 || isClicked === 3.5 ? pureWhite :headingBlue, 
                                    backgroundColor: isHovered === 3.5 || isClicked === 3.5 ? headingBlue : pureWhite
                                }}
                                onMouseEnter={() => setIsHovered(3.5)}
                                onMouseLeave={() => setIsHovered(0)}
                            >
                                <AssignmentIndIcon></AssignmentIndIcon>
                                {!isMobile &&
                                <Typography style={{...typographyStyle}}>Members</Typography>}
                            </ListItemButton>
                            <ListItemButton onClick={() => {
                                setIsclicked(3.6)
                                props.updateSelectedDashboard('Leads')
                            }}
                                style={{
                                    display: 'flex',
                                    //  justifyContent: 'space-between',
                                    color: isHovered === 3.6 || isClicked === 3.6 ? pureWhite :headingBlue, 
                                    backgroundColor: isHovered === 3.6 || isClicked === 3.6 ? headingBlue : pureWhite
                                }}
                                onMouseEnter={() => setIsHovered(3.6)}
                                onMouseLeave={() => setIsHovered(0)}    
                            >
                                <PersonAddIcon></PersonAddIcon>
                                {!isMobile &&
                                <Typography style={{...typographyStyle}}>Leads</Typography>}
                            </ListItemButton>

                        </List>
                    </Collapse>
                </>}
            </List>

        </Box>
    </>
  )
}

export default SideDrawer
